import React from 'react';
import './ContactUs.css';
import { useLanguage } from '../contexts/LanguageContext';

const ContactUs = () => {
    const { isArabic } = useLanguage();

    const googleMapsUrl = "https://www.google.com/maps/place/Freaks+Of+Nature+Festival/@24.7365632,46.809088,78153m/data=!3m1!1e3!4m6!3m5!1s0x3e2edf15e7f103b9:0xa8f6f8ec29fa485b!8m2!3d24.9938125!4d46.5115625!16s%2Fg%2F11sw3f1cq6!5m1!1e1?entry=ttu&g_ep=EgoyMDI2MDExMy4wIKXMDSoKLDEwMDc5MjA3MUgBUAM%3D";

    return (
        <div className="contact-us-page">
            <div className="contact-us-container">
                <h1>{isArabic ? 'تواصل معنا' : 'CONTACT US'}</h1>

                <div className="contact-options-wrapper">
                    {/* Email Card */}
                    <a href="mailto:hello@freaksofnature.me" className="contact-card">
                        <div className="contact-card-content">
                            <div className="icon-wrapper">
                                <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M22 6L12 13L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h3>hello@freaksofnature.me</h3>
                        </div>
                    </a>

                    {/* Location Card */}
                    <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer" className="contact-card">
                        <div className="contact-card-content">
                            <div className="icon-wrapper">
                                <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h3>{isArabic ? 'الموقع' : 'LOCATION'}</h3>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
